import "core-js/modules/es.array.push.js";
import Masonry from 'masonry-layout';
import Homehead from "@/Painting/home/home_head.vue";
import { post_Json } from "@/jsUtils/nodejsRequest";
import { fetchProductList } from '@/jsUtils/api/products';
import i18n from '@/lang';
export default {
  name: "product_main",
  components: {
    Homehead // 首页头部
  },

  data() {
    return {
      productlist: [],
      loading: true,
      error: null,
      placeholderImage: require('@/assets/painting/all_bg.jpg'),
      masonry: null
    };
  },
  mounted() {
    this.loadProducts();
  },
  activated() {
    if (this.masonry) {
      this.masonry.layout();
    }
  },
  computed: {
    currentLocale() {
      return i18n.global.locale.value;
    },
    loadingText() {
      return this.currentLocale === 'zh' ? '加载中…' : 'Loading…';
    },
    retryText() {
      return this.currentLocale === 'zh' ? '重试' : 'Retry';
    }
  },
  watch: {
    currentLocale() {
      this.loadProducts();
    }
  },
  // 方法
  methods: {
    async loadProducts() {
      this.loading = true;
      this.error = null;
      try {
        const data = await fetchProductList(this.currentLocale);
        let list = Array.isArray(data) ? [...data] : [];
        // 按 priority 倒序排序（数值越大越靠前），缺失/非数字按 0 处理
        list.sort((a, b) => {
          const pa = Number.isFinite(Number(a?.priority)) ? Number(a.priority) : 0;
          const pb = Number.isFinite(Number(b?.priority)) ? Number(b.priority) : 0;
          if (pb !== pa) return pb - pa;
          // 次级排序：保持稳定，按 name/slug 兜底
          const na = (typeof a?.name === 'string' ? a.name : a?.name?.zh || a?.name?.en || '') || a?.slug || '';
          const nb = (typeof b?.name === 'string' ? b.name : b?.name?.zh || b?.name?.en || '') || b?.slug || '';
          return na.localeCompare(nb);
        });
        this.productlist = list;
        // 等待 DOM 渲染后再初始化 Masonry
        this.$nextTick(() => {
          this.initializeMasonry();
        });
      } catch (err) {
        console.error('[product_main] loadProducts error', err);
        this.error = this.currentLocale === 'zh' ? '产品加载失败' : 'Failed to load products';
      } finally {
        this.loading = false;
      }
    },
    initializeMasonry() {
      if (!this.productlist.length) {
        return;
      }
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.destroy();
          this.masonry = null;
        }
        this.masonry = new Masonry('.product_container', {
          itemSelector: '.item',
          // 将以此选择器对应的元素作为瀑布流内容元素
          columnWidth: '.item',
          // 显式指定列宽，防止报错
          horizontalOrder: true,
          // 是否按水平顺序排列
          percentPosition: true // 支持百分比宽度
        });

        this.masonry.layout();
      });
    },
    imgLoaded(index) {
      // 这里的image load是异步的，所以需要使用nextTick。并且需要在image load之后，才能进行masonry的layout，否则会出现图片错位的情况
      this.$nextTick(() => {
        if (this.masonry) {
          this.masonry.layout();
          // console.log("image load and masonry layout " +  index);
        }
      });
    },

    onImageError(index) {
      if (this.productlist[index]) {
        this.productlist[index].coverImage = this.placeholderImage;
        this.productlist = [...this.productlist];
      }
    },
    onProductClick(slug) {
      if (!slug) {
        return;
      }
      this.$router.push({
        path: `/product/${slug}`
      });
      this.sendStatisticData(slug);
    },
    getName(item) {
      if (!item) return '';
      const locale = this.currentLocale;
      const name = item.name;
      // 兼容：name 可能是字符串，也可能是多语言对象
      if (typeof name === 'string') {
        return name;
      }
      if (name && typeof name === 'object') {
        if (name[locale]) return name[locale];
        if (name.zh) return name.zh;
        if (name.en) return name.en;
      }
      // 兜底：尝试 defaultTemplate.productName 或 slug
      if (item.defaultTemplate && item.defaultTemplate.productName) {
        return item.defaultTemplate.productName;
      }
      return item.slug || '';
    },
    //发送统计数据
    sendStatisticData(page) {
      let data = {
        "event": "product_click",
        "data": page
      };
      let stat_url = '/imageprocesshost' + '/statistic';
      post_Json(stat_url, data).then(res => {
        // 不做任何事情
      });
    }
  }
};